import { createSelector } from 'reselect';

export const subscriptionsSelector = state =>
  state.detailedBrokerageReducer.brokerageSubscriptions;

export const brokerageSummarySelector = createSelector(
  subscriptionsSelector,
  subscriptions => (subscriptions ? subscriptions.summary : null),
);
